import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../Zonas/ZonasListComponent.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash, faCalendar, faUsers } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import AsociadosDeLaLocalidadComponent from './AsociadosDeLaLocalidadComponent'
import Tooltip from '@mui/material/Tooltip';
import { useDispatch } from 'react-redux'
import { eliminarLocalidad } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'
import SubLocalidadesDeLocalidadComponent from './SubLocalidadesDeLocalidadComponent'
import DiasDeLaLocalidadComponent from './DiasDeLaLocalidadComponent'

import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';

library.add(faPen, faTrash, faCalendar, faUsers)

function LocalidadesDeLaZonaListItemComponent(props) {

    const zona = props.zona
    const localidad = props.localidad
    const dispatch = useDispatch()

    React.useEffect(() => {
        localidad
    }, [localidad])

    React.useEffect(() => {
        zona
    }, [zona])


    const [modalBorrarLocalidad, setModalBorrarLocalidad] = React.useState(false);
    const handleAbrirModalBorrarLocalidad = () => {
        setModalBorrarLocalidad(true);
    }

    const handleCerrarModalBorrarLocalidad = () => {
        setModalBorrarLocalidad(false);
    }

    const borrarLocalidad = () => {
        dispatch(eliminarLocalidad(localidad.idlocalidad))
        props.actualizarZonas()
        setModalBorrarLocalidad(false);
    }

    const [openModalCalendario, setOpenModalCalendario] = React.useState(false);
    const handleOpenModalCalendario = () => setOpenModalCalendario(true);
    const handleCloseModalCalendario = () => setOpenModalCalendario(false);

    const [openModalAsociados, setOpenModalAsociados] = React.useState(false);

    const [openModalSublocalidades, setOpenModalSublocalidades] = React.useState(false);

    const handleOpenModalAsociados = () => {
        setOpenModalAsociados(true)
    };

    const handleCloseModalAsociados = () => setOpenModalAsociados(false);

    const handleOpenModalSublocalidads = () => {
        if (props.localidad.latitud != "") {
            setOpenModalSublocalidades(true)
        } else {
            Store.addNotification({
                title: "Localidad no asignada en el mapa",
                message: "Edite la localidad y ubiquela en el mapa",
                type: "warning",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                }
            });
        }
    };

    const handleCloseModalSublocalidads = () => setOpenModalSublocalidades(false);

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1200, bgcolor: 'background.paper',
        border: '2px solid #000', boxShadow: 24, p: 4, overflow: 'scroll', height: '90%',
    };


    const styleModalConfirmacion = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center'
    };

    const HTMLmodalBorrarLocalidad = () => {
        return (
            <Modal
                open={modalBorrarLocalidad}
                onClose={handleCerrarModalBorrarLocalidad}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalConfirmacion} >
                    <h4>Borrar <strong>Localidad {localidad.nombre} </strong> <br />de la zona: <strong>{zona.nombreZona}</strong></h4><br />
                    Estás seguro de querer borrar esta localidad? <br></br>
                    Se estará borrando en cascada, es decir todo el contenido, así como el vinculo con sus asociados<br /><br />
                    <button onClick={() => borrarLocalidad()} className='btn btn-danger'>Si, estoy seguro</button>
                </Box>

            </Modal>
        )
    }


    const modalCalendario = () => {
        return (
            <div>
                <Modal
                    open={openModalCalendario}
                    onClose={handleCloseModalCalendario}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleModalConfirmacion}>
                        <h3>Dias asignados de Localidad</h3>
                        <DiasDeLaLocalidadComponent isLocalidad={true} onClose={handleCloseModalCalendario}></DiasDeLaLocalidadComponent>
                    </Box>
                </Modal>
            </div>
        )
    }



    //ASOCIADOS
    const modalAsociados = () => {
        return (
            <div>
                <Modal
                    open={openModalAsociados}
                    onClose={handleCloseModalAsociados}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        {/*<SubLocalidadesDeLocalidadComponent handleClose={props.handleClose} localidad={localidad} zona={zona} />*/}
                        <AsociadosDeLaLocalidadComponent localidad={localidad} zona={zona}></AsociadosDeLaLocalidadComponent>
                    </Box>
                </Modal>
            </div>
        )
    }

    const modalSublocalidades = () => {
        return (
            <div>
                <Modal
                    open={openModalSublocalidades}
                    onClose={handleCloseModalSublocalidads}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <SubLocalidadesDeLocalidadComponent handleClose={props.handleClose} localidad={localidad} zona={zona} />
                        {/* <AsociadosDeLaLocalidadComponent localidad={localidad} zona={zona}></AsociadosDeLaLocalidadComponent>*/}
                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            <div className={`alert alert-secondary ${estilos.alertItem}`} role="alert" id='index' >
                <div className='row'>
                    <div className='col-md-1 mt-4' style={{ paddingLeft: '7%', position: 'absolute' }}>
                        <div style={{ width: '20px', height: '20px', backgroundColor: props.localidad.pin, borderRadius: '50%' }}>

                        </div>
                    </div>
                    <div className='col-md-7 mt-3'>
                        <h5><strong>{props.localidad.nombrelocalidad}</strong></h5>
                        <p></p>
                    </div>
                    <div className='col-md-3' style={{ fontSize: '30px', textAlign: 'right' }}>

                        <Tooltip title="Editar localidad">
                            <button onClick={() => props.onEditarLocalidad(props.localidad)} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon icon={faPen} /></button>
                        </Tooltip>
                        {/* <Tooltip title="Borrar localidad">
                            <button onClick={() => handleAbrirModalBorrarLocalidad(props.localidad.idlocalidad)} className={`${estilos.botonItemZona} 
                            ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon icon={faTrash} /></button>
                        </Tooltip> */}
                        {/* <Tooltip title="Asignar días">
                            <button onClick={handleOpenModalCalendario} className={`${estilos.botonItemZona} 
                            ${estilos.zoom2} text-wrap text-center`} ><FontAwesomeIcon icon={faCalendar} /></button>
                        </Tooltip> */}
                        <Tooltip title="Ver Sublocalidades">
                            <button onClick={handleOpenModalSublocalidads} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`} ><FontAwesomeIcon icon={faUsers} /></button>
                        </Tooltip>
                    </div>
                </div>
            </div>
            <br />
            {modalCalendario()}
            {modalAsociados()}
            {HTMLmodalBorrarLocalidad()}
            {modalSublocalidades()}
        </Fragment>
    );
};


export default withRouter(LocalidadesDeLaZonaListItemComponent)
